import { render, staticRenderFns } from "./RewardRatio.vue?vue&type=template&id=c439a47e&scoped=true&"
import script from "./RewardRatio.vue?vue&type=script&lang=ts&"
export * from "./RewardRatio.vue?vue&type=script&lang=ts&"
import style0 from "./RewardRatio.vue?vue&type=style&index=0&id=c439a47e&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c439a47e",
  null
  
)

export default component.exports